/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { URLS } from '../../../constants/urls.constants';
import { setAlert } from '../../../store/modules/snackbar';
import { stopLoading } from '../../../store/modules/loading';
import { IStepTwoModel } from '../../../interfaces/stepTwo.interface';
import { useApiRequest, IResponsePayload } from '../../../hooks/useApiRequest';

const usePatchActivities = () => {
	const dispatch = useDispatch<any>();
	const { execute, status, value } = useApiRequest<
		any,
		IResponsePayload<IStepTwoModel>
	>({
		path: URLS.PROJECT.ACTIVITY,
		method: 'PATCH',
	});

	useEffect(() => {
		if (status === 'success') {
			dispatch(stopLoading());
		} else if (status === 'error') {
			dispatch(stopLoading());
			dispatch(
				setAlert({
					show: true,
					message: 'Ocurrio un error al crear el proyecto',
					severity: 'error',
				})
			);
		}
	}, [status]);

	return { execute, value };
};

export default usePatchActivities;
